import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import TakeAssessment from './components/TakeAssessment';
import ManageAssessments from './components/ManageAssessments';
import Dashboard from './components/Dashboard';
import AdvancedInsights from './components/InsightsDashboard';
import CalibrationReview from './components/CalibrationReview';
// import CalibrationModal from './components/CalibrationModal';
import ScheduleReview from './components/ScheduleReview';
import LoginPage from './components/LoginPage';
import Employees from './components/Employees';
import AdminCycleTemplate from './components/AdminCycleTemplate';
import Roles from './components/Roles';
import DepartmentManagement from './components/DepartmentManagement';
import MOMAuthCallback from './components/MOMAuthCallback';
import './App.css';
 
function RequireAuth({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);
 
  useEffect(() => {
    // Check for token on mount
    const token = typeof window !== 'undefined' ? sessionStorage.getItem('access_token') : null;
    setHasToken(!!token);
    setIsChecking(false);
  }, []);
 
  // Show nothing while checking to prevent flash
  if (isChecking) {
    return null;
  }
 
  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }
 
  return children;
}

//Disable inspect element
// function RequireAuth({ children }) {
//   const [isChecking, setIsChecking] = useState(true);
//   const [hasToken, setHasToken] = useState(false);

//   useEffect(() => {
//     const token = sessionStorage.getItem('access_token');
//     setHasToken(!!token);
//     setIsChecking(false);
//   }, []);

//   // 🚫 Disable inspect ONLY after login
//   useEffect(() => {
//     if (!hasToken) return;

//     const disableContext = (e) => e.preventDefault();
//     document.addEventListener("contextmenu", disableContext);

//     const disableShortcuts = (e) => {
//       if (
//         e.key === "F12" ||
//         (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "C")) ||
//         (e.ctrlKey && e.key === "U")
//       ) {
//         e.preventDefault();
//       }
//     };
//     document.addEventListener("keydown", disableShortcuts);

//     return () => {
//       document.removeEventListener("contextmenu", disableContext);
//       document.removeEventListener("keydown", disableShortcuts);
//     };
//   }, [hasToken]);

//   if (isChecking) return null;

//   if (!hasToken) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// }

 
// function RequireManager({ children }) {
//   const [isChecking, setIsChecking] = useState(true);
//   const [hasToken, setHasToken] = useState(false);
//   const [isManager, setIsManager] = useState(false);
 
//   useEffect(() => {
//     // Check for token and manager role on mount
//     const token = typeof window !== 'undefined' ? sessionStorage.getItem('access_token') : null;
//     const accessRole = typeof window !== 'undefined' ? sessionStorage.getItem('access_role') : null;
   
//     setHasToken(!!token);
//     setIsManager(accessRole === 'manager');
//     setIsChecking(false);
   
//     console.log('🔐 RequireManager check - Token:', !!token, 'Access Role:', accessRole);
//   }, []);
 
//   // Show nothing while checking to prevent flash
//   if (isChecking) {
//     return null;
//   }
 
//   if (!hasToken) {
//     return <Navigate to="/login" replace />;
//   }
 
//   if (!isManager) {
//     console.log('⛔ Access denied - Manager role required');
//     return <Navigate to="/Home" replace />;
//   }
 
//   return children;
// }
function RequireManager({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const token = typeof window !== 'undefined' ? sessionStorage.getItem('access_token') : null;
    const accessRole = typeof window !== 'undefined' ? sessionStorage.getItem('access_role')?.toLowerCase() : null;

    setHasToken(!!token);
    // ✅ Allow both admin and manager
    setHasAccess(accessRole === 'manager' || accessRole === 'admin');
    setIsChecking(false);

    console.log('🔐 RequireManager check - Token:', !!token, 'Access Role:', accessRole);
  }, []);

  if (isChecking) return null;

  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccess) {
    console.log('⛔ Access denied - Manager/Admin role required');
    return <Navigate to="/Home" replace />;
  }

  return children;
}

function RequireAdmin({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = typeof window !== 'undefined' ? sessionStorage.getItem('access_token') : null;
    const accessRole = typeof window !== 'undefined' ? sessionStorage.getItem('access_role')?.toLowerCase() : null;

    setHasToken(!!token);
    setIsAdmin(accessRole === 'admin');
    setIsChecking(false);

    console.log('RequireAdmin check - Token:', !!token, 'Access Role:', accessRole);
  }, []);

  if (isChecking) return null;

  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    console.log('Access denied - Admin role required');
    return <Navigate to="/Home" replace />;
  }

  return children;
}

function RootRedirect() {
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);
 
  useEffect(() => {
    // Check for token on mount
    const token = typeof window !== 'undefined' ? sessionStorage.getItem('access_token') : null;
    setHasToken(!!token);
    setIsChecking(false);
  }, []);
 
  // Show nothing while checking to prevent flash
  if (isChecking) {
    return null;
  }
 
  return <Navigate to={hasToken ? "/Home" : "/login"} replace />;
}
 
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/Home" element={<RequireAuth><HomePage /></RequireAuth>} />
          <Route path="/takeassessment" element={<RequireAuth><TakeAssessment /></RequireAuth>} />
          <Route path="/employees" element={<RequireManager><Employees /></RequireManager>} />
          <Route path="/manageassessments" element={<RequireManager><ManageAssessments /></RequireManager>} />
          <Route path="/dashboard" element={<RequireManager><Dashboard /></RequireManager>} />
            <Route path="/insights" element={<RequireAdmin><AdvancedInsights /></RequireAdmin>} />
          <Route path="/calibrationreview" element={<RequireAuth><CalibrationReview /></RequireAuth>} />
          {/* <Route path="/calibration/:email/:cycleId/details" element={<RequireAuth><CalibrationModal /></RequireAuth>} /> */}
          <Route path="/schedulereview/:personname" element={<RequireAuth><ScheduleReview /></RequireAuth>} />
          <Route path="/assessment-cycles" element={<RequireAuth><RequireAdmin><AdminCycleTemplate/></RequireAdmin></RequireAuth>} />
          <Route path="/roles" element={<RequireManager><Roles /></RequireManager>}/>
          <Route path="/department-management" element={<RequireManager><DepartmentManagement /></RequireManager>}/>
          <Route path="/mom-auth-callback" element={<MOMAuthCallback />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </div>
    </Router>
  );
}
 
export default App;